module.exports = __webpack_public_path__ + "fonts/ClearSans-Thin-webfont128ac718c9526897c71b70c93a5385bd.ttf";